module.exports = __webpack_public_path__ + "img/wetNwildGloss1.c16210aa.jpg";